/**
 * App — корневой компонент.
 * Provider-ы: QueryClient (в main.tsx). Здесь — RouterProvider (data-router).
 *
 * data-router (createBrowserRouter) нужен, чтобы useBlocker в useUnsavedChanges
 * работал — на обычном BrowserRouter он бросает ошибку и рендерит blank screen.
 */
import { RouterProvider } from 'react-router-dom';

import { router } from './router';

export default function App() {
  return <RouterProvider router={router} />;
}